import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";
import { ToastContainer } from "react-toastify";
import Table from "../../components/Table";

export default function CustomerContracts({ lang = {} }) {
  const [contracts, setContracts] = useState([]);
  const [selectedContract, setSelectedContract] = useState(null);
  const [receipts, setReceipts] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);

  useEffect(() => {
    fetchContracts();
  }, []);

  const fetchContracts = () => {
    const session = JSON.parse(sessionStorage.getItem("aman-customer") || "{}");
    const token = session.token;
    if (!token) return;

    axios
      .get(`${apiKey}/customer-panel/contracts`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setContracts(res.data.contracts || []);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleViewDetails = (id) => {
    const session = JSON.parse(sessionStorage.getItem("aman-customer") || "{}");
    const token = session.token;
    setModalLoading(true);

    axios
      .get(`${apiKey}/customer-panel/contracts/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setSelectedContract(res.data.contract);
        setReceipts(res.data.receipts || []);
        setModalLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setModalLoading(false);
      });
  };

  const columns = [
    {
      header: lang["SN"] || "SN",
      cell: (row) => row.row.index + 1,
    },
    {
      header: lang["Contract ID"] || "Contract ID",
      accessorKey: "id",
      cell: (row) => <span className="fw-bold text-primary">#{row.getValue()}</span>,
    },
    {
      header: lang["Branch_Name"] || "Branch Name",
      accessorKey: "branch_name",
      cell: (row) => row.getValue() || "Main Branch",
    },
    {
      header: lang["Total_Value"] || "Total Contract Value",
      accessorKey: "total_value",
      cell: (row) => `SAR ${Number(row.getValue() || 0).toLocaleString()}`,
    },
    {
      header: lang["Paid_Amount"] || "Paid Amount",
      accessorKey: "total_paid",
      cell: (row) => (
        <span className="text-success fw-bold">
          SAR {Number(row.getValue() || 0).toLocaleString()}
        </span>
      ),
    },
    {
      header: lang["Remaining"] || "Remaining",
      cell: (row) => {
        const total = Number(row.row.original.total_value || 0);
        const paid = Number(row.row.original.total_paid || 0);
        const remaining = Math.max(0, total - paid);
        return (
          <span className="text-danger fw-bold">
            SAR {remaining.toLocaleString()}
          </span>
        );
      },
    },
    // {
    //   header: lang["Payment_Progress"] || "Payment Progress",
    //   cell: (row) => {
    //     const total = Number(row.row.original.total_value || 0);
    //     const paid = Number(row.row.original.total_paid || 0);
    //     const progress = total > 0 ? Math.min(100, Math.round((paid / total) * 100)) : 0;
    //     return (
    //       <div style={{ minWidth: "120px" }}>
    //         <div className="d-flex align-items-center">
    //           <div className="progress flex-grow-1 me-2" style={{ height: "8px" }}>
    //             <div
    //               className="progress-bar bg-success"
    //               role="progressbar"
    //               style={{ width: `${progress}%` }}
    //             ></div>
    //           </div>
    //           <span className="small fw-bold">{progress}%</span>
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    {
      header: lang["Status"] || "Status",
      accessorKey: "status",
      cell: (row) => {
        const status = parseInt(row.getValue());
        return status === 1 ? (
          <span className="badge rounded-pill bg-success">{lang.active || "Active"}</span>
        ) : status === 2 ? (
          <span className="badge rounded-pill bg-primary">{lang.completed || "Completed"}</span>
        ) : (
          <span className="badge rounded-pill bg-secondary">{lang.closed || "Closed"}</span>
        );
      },
    },
    {
      header: lang["Actions"] || "Actions",
      cell: (row) => (
        <button
          className="btn btn-sm btn-primary px-3 shadow-sm"
          data-bs-toggle="modal"
          data-bs-target="#contractDetailModal"
          onClick={() => handleViewDetails(row.row.original.id)}
        >
          <i className="fa fa-file-invoice me-1"></i> {lang.View_Details || "View Details"}
        </button>
      ),
    },
  ];

  return (
    <div className="container-fluid px-4 py-3">
      <ToastContainer />
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.My_Contracts || "My Contracts"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">{lang.Home || "Home"}</li>
            <li className="breadcrumb-item active">{lang.My_Contracts || "My Contracts"}</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">
                  {lang.All_Contract_Records || "All Contract Records"}
                </div>
              </div>
              <div className="card-body">
                <div className="d-flex mt-3 mb-3">
                  <Table
                    columns={columns}
                    data={contracts}
                    lang={lang}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contract Detail Modal */}
      <div className="modal fade" id="contractDetailModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content border-0 shadow-lg rounded-4">
            <div className="modal-header bg-primary text-white">
              <h5 className="modal-title fw-bold">
                Contract Details #{selectedContract?.id}
              </h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body p-4">
              {modalLoading ? (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary" role="status"></div>
                </div>
              ) : selectedContract ? (
                <>
                  <div className="row g-3 mb-4 bg-light p-3 rounded-3 border">
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Branch:</span>
                      <strong className="text-dark">{selectedContract.branch_name || "N/A"}</strong>
                    </div>
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Schedule Type:</span>
                      <strong>{selectedContract.schedule_type || "Monthly"}</strong>
                    </div>
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Installments Count:</span>
                      <strong>{selectedContract.no_of_installments || "N/A"}</strong>
                    </div>
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Total Contract Value:</span>
                      <strong className="text-primary fs-5">SAR {Number(selectedContract.total_value).toLocaleString()}</strong>
                    </div>
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Total Paid:</span>
                      <strong className="text-success fs-5">SAR {Number(selectedContract.total_paid || 0).toLocaleString()}</strong>
                    </div>
                    <div className="col-md-4">
                      <span className="small text-muted d-block">Remaining Balance:</span>
                      <strong className="text-danger fs-5">SAR {Number(selectedContract.total_value - (selectedContract.total_paid || 0)).toLocaleString()}</strong>
                    </div>
                  </div>

                  <h6 className="fw-bold mb-3 border-bottom pb-2">Payment Receipts & History</h6>
                  {receipts.length === 0 ? (
                    <p className="text-muted small">No payment receipts recorded yet for this contract.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-bordered align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Receipt ID</th>
                            <th>Amount (SAR)</th>
                            <th>Discount</th>
                            <th>Payment Method</th>
                            <th>Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {receipts.map((rec) => (
                            <tr key={rec.id}>
                              <td>#{rec.id}</td>
                              <td className="fw-bold text-success">SAR {Number(rec.amount).toLocaleString()}</td>
                              <td>SAR {Number(rec.discount || 0).toLocaleString()}</td>
                              <td>{rec.payment_method || "Cash"}</td>
                              <td>{rec.date ? new Date(rec.date).toLocaleDateString() : "N/A"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
